module.exports = {"rE":"6.0.0"}